export const EP = 1
export const ASSINATURA_SUPORTE = 2
export const ACOMPANHAMENTO_BASICO = 116
export const ACOMPANHAMENTO_ESSENCIAL = 117
export const ACOMPANHAMENTO_ELITE = 118
export const GESTAO_FINANCEIRA = 222
export const APP_MEU_FUTURO_MENSAL = 274
export const APP_MEU_FUTURO_ANUAL = 275
export const SUPORTE_OPEN = 276
export const ACOMPANHAMENTO_BASICO_OPEN = 277
export const ACOMPANHAMENTO_ESSENCIAL_OPEN = 278
export const ACOMPANHAMENTO_ELITE_OPEN = 279